<template>
  <div class="container p-5">
    <vs-breadcrumb :items="[
        { title: 'Seguridad', url: '/security' },
        { title: 'Navegación', active: true }
    ]"></vs-breadcrumb>
    <vx-card title="Menu">

      <div class="flex flex-row-reverse">
        <vs-button @click="createMenuDialogHandler">Agregar nuevo</vs-button>
      </div>

      <vs-table :data="menus" class="mt-2">
        <template slot="thead">
          <vs-th>ID</vs-th>
          <vs-th>Nombre</vs-th>
          <vs-th>Descripción</vs-th>
          <vs-th>Opciones</vs-th>
        </template>
        <template slot-scope="{data}">
          <vs-tr v-for="menu in data">
            <vs-td>{{ menu.id }}</vs-td>
            <vs-td>{{ menu.title }}</vs-td>
            <vs-td>{{ menu.description }}</vs-td>
            <vs-td>
              <vs-button
                size="small"
                type="border"
                color="primary"
                @click="editMenuDialogHandler(menu)">
                Editar
              </vs-button>
              <vs-button
                size="small"
                class="ml-2"
                type="border"
                color="danger"
                :to="`/security/navigation/menu/${menu.id}/edit`">
                Administrar
              </vs-button>
            </vs-td>
          </vs-tr>
        </template>
      </vs-table>
    </vx-card>

    <vs-popup title="Editar menú" :active.sync="showEditPopup">
      <div v-if="menuSelected !== null">
        <vs-input
          v-model="menuSelected.title"
          label="Título"
          class="w-full"
        ></vs-input>

        <vs-textarea
          class="mt-2"
          v-model="menuSelected.description"
          label="Descripción"
        ></vs-textarea>
        <vs-button class="mt-5" @click="updateMenuConfirm()">
          Guardar cambios
        </vs-button>
      </div>
    </vs-popup>


    <vs-popup title="Crear nuevo menú" :active.sync="showCreatePopup">
      <div>
        <vs-input
            v-model="form.title"
            label="Título"
            class="w-full"
        ></vs-input>

        <vs-textarea
            class="mt-2"
            v-model="form.description"
            label="Descripción"
        ></vs-textarea>
        <vs-button class="mt-5" @click="createMenuConfirm()">
          Crear
        </vs-button>
      </div>
    </vs-popup>

  </div>
</template>

<script>

export class Menu {
  constructor(id, title, description, items) {
    this.id = id;
    this.title = title;
    this.description = description;
    this.items = items;
  }
}

export default {
  name: "MenuManager",
  data: () => ({
    menus: [],
    showEditPopup: false,
    showCreatePopup: false,
    menuSelected: null,
    form: {
      title: null,
      description: null
    }
  }),
  async mounted() {
    const {data} = await axios.get('/api/backoffice/navigation/menu');
    this.menus = data;
  },
  methods: {
    createMenuDialogHandler() {
      this.showCreatePopup = true;
    },
    async editMenuDialogHandler(menu) {
      this.showEditPopup = true;
      this.menuSelected = menu;
    },
    async updateMenuConfirm() {
      this.$vs.loading();
      try {
        await axios.put('/api/backoffice/navigation/menu/' + this.menuSelected.id, {
          title: this.menuSelected.title,
          description: this.menuSelected.description,
        })
        this.showEditPopup = false;
        this.successNotif('¡Listo!', 'El menú se guardo correctamente')
      } catch (e) {
        this.$vs.loading.close();
      } finally {
        this.$vs.loading.close();
      }
    },
    async createMenuConfirm() {
      this.$vs.loading();
      try {
        let {data} = await axios.post('/api/backoffice/navigation/menu', {
            title: this.form.title,
            description: this.form.description,
          }
        );
        this.showCreatePopup = false;
        this.successNotif('¡Listo!', 'El menú se guardo correctamente')
        this.menus.push(data);
      } finally {
        this.$vs.loading.close();
      }
    }
  }
}
</script>

<style scoped>

</style>